import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import FamilyMember from '@/components/MainFlow/AddSubscriptions/AddFamilyPhoneItem/FamilyMember'

import { validateFamily } from '@/lib/family_validation'
import config from '@/config/config-esm'
import { setFormData } from '@/store/slices/formDataSlice'

const FamilyStep3Component = ({ onClose }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const formData = useSelector((state) => state.formData)
  const appData = useSelector((state) => state.appData)
  const layout = useSelector((state) => state.layout)
  
  const [ownerSet, setOwnerSet] = useState(false)
  const [editing, setEditing] = useState(false)

  const allowNext = () => {
    return validateFamily(formData.family)
  }

  const prevStep = () => {
    dispatch(setFormData({ familyStep: 'owner' }))
  }

  const finish = () => {
    dispatch(
      setFormData({
        newFamilyPhoneSession: false,
        familyStep: 'members',
        family: { ...formData.family, completed: true },
      }),
    )
    onClose()
  }

  const toggleEditing = () => {
    setEditing(!editing)
  }

  const { departmentId } = layout.data
  const { chatDepartmentIds } = config
  const { members } = formData.family
  let duplicatePhoneNo = false
  for (let member of members) {
    if (member.phone) {
      const same = members.filter((m) => m.phone === member.phone)
      if (same.length > 1) {
        duplicatePhoneNo = [same[0].phone]
        break
      }
    }
  }

  return (
      <div>
        <h1>Flokken</h1>
        <div>
          {members.map((item, i) => {
            return (
              <FamilyMember key={item.id} member={item} i={i} toggleEditing={toggleEditing} />
            )
          })}
        </div>

        <h1 className="space-above">Bestillingen</h1>
        <div className="toggles">
          <div className={`${formData.family.digitalSafety === true ? 'ok' : ''}`}>
            <div>
              <div>Digital trygghet</div>
              <div className="toggle-buttons">
                <div
                  className={`oh-yeah ${formData.family.digitalSafety === true ? 'active' : ''}`}
                  onClick={(e) =>
                    dispatch(setFormData({ family: { ...formData.family, digitalSafety: true } }))
                  }
                >
                  Ja takk!
                </div>
                <div
                  className={`oh-noes ${formData.family.digitalSafety === false ? 'active' : ''}`}
                  onClick={(e) =>
                    dispatch(setFormData({ family: { ...formData.family, digitalSafety: false } }))
                  }
                >
                  Nei takk
                </div>
              </div>
            </div>
          </div>
          {/* <div className="input_wrapper">
            <input type="checkbox"
              value={1}
              id="buyoutDiscount"
              checked={formData.family.buyoutDiscount}
              onChange={e => {
                dispatch(setFormData({ family: { ...formData.family, buyoutDiscount: !formData.family.buyoutDiscount } }))
              }} />
            <label htmlFor="buyoutDiscount"><span>Utkjøpsrabatt</span></label>
          </div> */}
          {/* <div className="input_wrapper">
            <input type="checkbox"
              value={1}
              id="portDiscount"
              checked={formData.family.portDiscount}
              onChange={e => {
                dispatch(setFormData({ family: { ...formData.family, portDiscount: !formData.family.portDiscount } }))
              }} />
            <label htmlFor="portDiscount"><span>Porteringsrabatt</span></label>
          </div> */}
        </div>
        {chatDepartmentIds.includes(departmentId) && (
          <div className="input_wrapper">
            <label htmlFor="recruited-by">
              <span>Rekruttert av</span>
            </label>
            <input
              type="text"
              id="recruited-by"
              value={formData.family.recruitedBy || ''}
              onChange={(e) =>
                dispatch(
                  setFormData({ family: { ...formData.family, recruitedBy: e.target.value } }),
                )
              }
            />
          </div>
        )}

        {duplicatePhoneNo && (
          <div className="partly-verified-container">
            <div>
              Telefonnummeret {duplicatePhoneNo} er registrert flere ganger. Dette må korrigeres før
              du kan gå videre.
            </div>
          </div>
        )}

        {!editing && (
          <div className="buttons">
            <button className="cancel" onClick={prevStep}>
              Tilbake
            </button>
            <button
              className="continue"
              disabled={!allowNext() || duplicatePhoneNo}
              onClick={finish}
            >
              Fullfør
            </button>
          </div>
        )}
      </div>
  )
}

export default FamilyStep3Component
